// @ts-ignore
// @ts-nocheck
import { AxiosError, AxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';
import api from 'services/api';
import { getAccessToken } from './accessTokenServices';

type ErrorData = {
  response: {
    data: {
      message: string;
    };
    status: string;
  };
};

export type ConsultantDataReponse = {
  name: string;
  email: string;
  phone: string;
  consultantName: string;
  photo?: string;
};

export const getConsultants = async (): Promise<ConsultantDataReponse[]> => {
  const access_token = await getAccessToken();
  let constultantsData: ConsultantDataReponse[] = [] as ConsultantDataReponse[];

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'GET',
    headers: header,
  } as AxiosRequestConfig;

  try {
    const customerSiteCode = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteCode'
    );
    const params = customerSiteCode ? `?site-code=${customerSiteCode}` : '';

    const response = await api.get(
      `industrial/customer/v1/customers/me/consultants${params}`,
      parameters
    );
    const payload = response.data;
    constultantsData = Array.isArray(payload)
      ? payload
      : payload
      ? [payload]
      : [];
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      const { message } = errorResponse.response.data;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }
  }

  return constultantsData;
};
